import {WebsiteActions} from "./actions";
import {notifyError, notifySuccess} from "@nutastic/nutastic-react-app";

const reducer = (state, action) => {
    switch (action.type) {
        case WebsiteActions.LOADING_PAGE_START:
        case WebsiteActions.REUP_STARTED: {
            return {
                ...state,
                isProcessing: true
            };
        }

        case WebsiteActions.LOADING_PAGE_FAIL:
        case WebsiteActions.REUP_FAIL:
        case WebsiteActions.REUP_DONE:
        case WebsiteActions.LOADING_PAGE_DONE: {
            return {
                ...state,
                isProcessing: false
            };
        }

        case WebsiteActions.REGISTER_STARTED:
        case WebsiteActions.LOGIN_STARTED: {
            return {
                ...state,
                authState: {
                    ...(state.authState || {}),
                    isProcessingLogin: true,
                    isAuthenticated: false
                }
            };
        }

        case WebsiteActions.REGISTER_COMPLETE:
        case WebsiteActions.LOGIN_COMPLETE: {
            const { accountInfo } = action;

            return {
                ...state,
                authState: {
                    ...(state.authState || {}),
                    isProcessingLogin: false,
                    isAuthenticated: true,
                    authError: '',
                    accountInfo
                }
            };
        }

        case WebsiteActions.REGISTER_FAIL:
        case WebsiteActions.LOGIN_FAILED: {
            const { authError } = action;

            return {
                ...state,
                authState: {
                    ...(state.authState || {}),
                    isProcessingLogin: false,
                    isAuthenticated: false,
                    authError,
                    accountInfo: null
                }
            };
        }

        case WebsiteActions.LOGOUT: {
            return {
                ...state,
                authState: {
                    ...(state.authState || {}),
                    accountInfo: null,
                    isAuthenticated: false,
                    isProcessingLogin: false,
                    authError: ''
                }
            };
        }

        case WebsiteActions.ACCOUNT_MODAL_SHOW: {
            return {
                ...state,
                accountState: {
                    isActive: true
                }
            }
        }

        case WebsiteActions.ACCOUNT_MODAL_HIDE: {
            return {
                ...state,
                accountState: {
                    isActive: false
                }
            }
        }

        default:
            return state;
    }
};

export default reducer;
